import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const GroupInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 10rem;
`;

export const GroupDetailStyled = styled.b`
  margin: 0;
  font-size: 1.8rem;
  color: ${colors.neutral[900]};
`;

export const TitleStyled = styled.b`
  color: ${colors.neutral[600]};
  margin-right: 1rem;
`;

export const ValueStyled = styled.span`
  margin: 0;
  font-size: 1.6rem;
`;

export const SectionTitleStyled = styled.h3`
  ${typography.bold[18]};
  color: ${colors.neutral[700]};
  text-transform: uppercase;
  margin: 0 0 1.6rem;
`;
